import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { checkGate } from '../../lib/api/gate';
import ComingSoon from './ComingSoon';
import Logo from '../../assets/img/logo/sanasa-logo-white.png';

// Shows the coming soon page instead of the website while the gate is on (Back office > Settings).
// The back office itself (/admin) is never covered, so staff can always sign in.
// Until the check is done nothing of the site is shown, so locked visitors never see a flash of it.
const PreviewGate = ({ children }) => {
  const { pathname } = useLocation();
  const [state, setState] = useState('checking'); // checking | open | locked | error
  const isAdmin = pathname.startsWith('/admin');

  useEffect(() => {
    if (isAdmin || state !== 'checking') return undefined;
    let alive = true;
    checkGate().then((result) => {
      if (alive) setState(result);
    });
    return () => {
      alive = false;
    };
  }, [isAdmin, state]);

  if (isAdmin || state === 'open') return children;

  if (state === 'locked') return <ComingSoon onUnlocked={() => setState('open')} />;

  return (
    <main className="sc-soon sc-soon--plain">
      <img className="sc-soon__logo" src={Logo} alt="SANASA Campus Ltd." width="240" />
      {state === 'error' && (
        <div className="sc-soon__retry">
          <p>We could not load the site just now.</p>
          <button type="button" onClick={() => setState('checking')}>
            Try again
          </button>
        </div>
      )}
    </main>
  );
};

export default PreviewGate;
